import { getConfig } from '@edx/frontend-platform';
import { getAuthenticatedHttpClient } from '@edx/frontend-platform/auth';

/**
 * Fetches the progress overview for the current authenticated user
 * @async
 * @returns {Promise<Object>} Progress overview data
 */
export const fetchProgressOverview = async () => {
  let url = `${getConfig().LMS_BASE_URL}/blendxapi/learner/progress/overview/`;
  const { data } = await getAuthenticatedHttpClient().get(url);
  return data;
};

/**
 * Fetches course summary data for a specific user
 * @async
 * @param {string} userId - The ID of the user to fetch course summary for
 * @returns {Promise<Object>} Course summary data
 */
export const fetchCourseSummary = async (userId) => {
  let url = `${getConfig().LMS_BASE_URL}/blendxapi/learner/progress/course-summary/${userId}/`;
  const { data } = await getAuthenticatedHttpClient().get(url);
  return data;
};

/**
 * Fetches course engagement data for a specific user within a date range
 * @async
 * @param {string} userId - The ID of the user to fetch course engagement for
 * @param {string} startDate - Start date for the engagement period in ISO format
 * @param {string} endDate - End date for the engagement period in ISO format
 * @returns {Promise<Object>} Course engagement data
 */
export const fetchCourseEngagement = async (userId, startDate, endDate) => {
  let url = `${getConfig().LMS_BASE_URL}/blendxapi/learner/progress/course-engagement/${userId}/${startDate}/${endDate}/`;
  const { data } = await getAuthenticatedHttpClient().get(url);
  return data;
};

/**
 * Fetches the last completed course unit for the current authenticated user
 * @async
 * @returns {Promise<Object>} Last completed course unit data
 */
export const fetchLastCompletedCourseUnit = async () => {
  let url = `${getConfig().LMS_BASE_URL}/blendxapi/learner/resume_learning/`;
  const { data } = await getAuthenticatedHttpClient().get(url);
  return data;
};

/**
 * Fetches streak data for the current authenticated user
 * @async
 * @returns {Promise<Object>} User's streak data
 */
export const fetchStreakData = async () => {
  let url = `${getConfig().LMS_BASE_URL}/blendxapi/learner/progress/streak/`;
  const { data } = await getAuthenticatedHttpClient().get(url);
  return data;
};
